import { render, staticRenderFns } from "./ExtractTable.vue?vue&type=template&id=c438f9ba&scoped=true"
import script from "./ExtractTable.vue?vue&type=script&lang=js"
export * from "./ExtractTable.vue?vue&type=script&lang=js"
import style0 from "./ExtractTable.vue?vue&type=style&index=0&id=c438f9ba&prod&lang=postcss&scoped=true"


/* normalize component */
import normalizer from "!../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  "c438f9ba",
  null
  
)

export default component.exports